module.exports = __webpack_public_path__ + "img/zhyj-2.68806684.png";